module.exports = __webpack_public_path__ + "static/media/icon_modify.bb7cae7c.svg";